import styled, { css, keyframes } from 'styled-components'
import _times from 'lodash/times'
export const Tooltip = styled.div`
  ul {
    margin: 0;
    padding-inline-start: 20px;
  }
`

const animationKeys = keyframes`
  0% {
    background-color: hsla(200, 20%, 75%, .4);
  }
  100% {
    background-color: hsla(200, 20%, 90%, .4);
  }
`

const animation = (props) =>
  props.animated == false
    ? 'none'
    : css`
        animation: ${animationKeys} 1s linear infinite alternate;
      `
export const MonthCalendarContainer = styled.div`
  .niara-month-calendar-title {
    text-transform: capitalize;
    text-align: center;
    font-size: 14px;
    padding: 0px 20px;
    margin-bottom: 40px;
    text-align: left;
    font-weight: bold;
    color: ${({ theme }) => theme.colors.textColor};
    vertical-align: middle;
    margin-top: 20px;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      margin-top: 0px;
      margin-bottom: 17px;
      height: 28px;
      line-height: 22px;
      text-align: center;
      font-size: 13px;
      padding: 0px;
    }
  }
  .niara-month-calendar-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    gap: 1px;
    .niara-month-calendar-weekday {
      display: none;
      @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
        display: block;
        text-align: center;
        line-height: 16px;
        height: 16px;
        font-size: 11px;
        text-transform: uppercase;
        margin-top: 0px;
        color: ${({ theme }) => theme.colors.gray4};
        font-weight: 600;
      }
    }
    .niara-month-calendar-cell {
      ${() =>
        _times(
          6,
          (i) => css`
            &.first-day-${i + 1} {
              grid-column-start: ${i + 2};
            }
          `
        )}
      display: flex;
      align-items: stretch;

      .niara-month-calendar-button {
        font-family: Manrope,sans-serif;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        width: 100%;
        border: none;
        background-color: ${({ theme }) => theme.colors.white};
        font-size: 14px;
        font-weight: 700;
        height: 55px;
        border-color: ${({ theme }) => theme.colors.gray3};
        border-width: 1px;
        border-style: solid;
        padding: 0;
        &:hover,
        &.in-selection,
        &.in-selection:hover,
        &.in-selection:focus {
          background-color: ${({ theme }) => theme.colors.gray3};
          color: ${({ theme }) => theme.colors.textColor};
        }
        &.active,
        &.active:hover,
        &.active:focus {
          background-color: ${({ theme }) => theme.colors.primary};
          color: ${({ theme }) => theme.colors.primaryReadable};
        }
        &:disabled,
        &.disabled {
          background-color: ${({ theme }) => theme.colors.gray3};
          color: ${({ theme }) => theme.colors.gray5};
          cursor: not-allowed;
        }
        .day {
          padding-top: 6px;
          line-height: 20px;
          margin-bottom: 6px;
        }
        &.unavailable {
          .day {
            text-decoration: line-through;
          }
        }
        .unavailable-icon {
          position: absolute;
          top: 0;
          right: 0;
          color: ${({ theme }) => theme.colors.danger} !important;
          font-size: 12px;
          line-height: 1em;
        }
        .min-nights {
          position: absolute;
          top: 0;
          left: 0;
          width: 15px;
          height: 15px;
          font-size: 9px;
          background-color: ${({ theme }) => theme.colors.gray3};
          border-radius: 0px 0px 4px 0px;
        }
        .price {
          font-weight: 400;
          font-size: 11px;
          @media (max-width: calc(${({ theme }) => theme.breakpoints.sm} - 1px)) {
            font-size: 10px;
          }
        }
        .loading-indicator {
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: hsla(200, 20%, 80%, 0.4);
          border-radius: 5px;
          box-sizing: border-box;
          ${animation};
          width: 50%;
          height: 7px;
          margin-top: 5px;
        }
      }
    }
  }
`
